import React, { useEffect, useState } from "react";

interface ActionCountdownProps {
  /** ISO 8601 datum konce akce (z API `action_price_to`, formát `Y-m-d\TH:i:sP`). */
  until: string;
}

const pad = (n: number) => String(n).padStart(2, "0");

/** Česká skloňovaná forma "den / dny / dní". */
const dayWord = (d: number) => (d === 1 ? "den" : d >= 2 && d <= 4 ? "dny" : "dní");

/**
 * Odpočet do konce platnosti akční ceny. Tiká po sekundě a po vypršení
 * (nebo při neplatném datu) se sám schová — render se o viditelnost nestará.
 */
const ActionCountdown: React.FC<ActionCountdownProps> = ({ until }) => {
  const target = new Date(until).getTime();
  const [remaining, setRemaining] = useState<number>(() => target - Date.now());

  useEffect(() => {
    const tick = () => setRemaining(target - Date.now());
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [target]);

  if (isNaN(target) || remaining <= 0) return null;

  const totalSec = Math.floor(remaining / 1000);
  const days = Math.floor(totalSec / 86400);
  const hours = Math.floor((totalSec % 86400) / 3600);
  const minutes = Math.floor((totalSec % 3600) / 60);
  const seconds = totalSec % 60;

  return (
    <div className="action-countdown" role="timer" aria-live="off">
      <span className="action-countdown__label">Akce končí za</span>
      <span className="action-countdown__time">
        {days > 0 ? `${days} ${dayWord(days)} ` : ""}
        {pad(hours)}:{pad(minutes)}:{pad(seconds)}
      </span>
    </div>
  );
};

export default ActionCountdown;
